import React, {useEffect} from "react";
import styled from "@emotion/styled";
import logoAsset from "assets/images/logos/logoWhite.png";
import {useTranslation} from "react-i18next";
import {AdobeAnalyticService} from "modules/utils/Services/AdobeAnalyticService";
import {AdobeTrackStateActions} from "modules/enums";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	height: 100%;

	img {
		max-width: 300px;
		max-height: 100px;
		width: auto;
		height: 100%;
		margin: 36px 0;
	}

	p {
		font-style: normal;
		font-weight: 400;
		font-size: 18px;
		line-height: 24px;
		text-align: center;
		color: ${({theme}) => theme.colors.text.white};
		margin-bottom: 24px;
	}

	p.title {
		font-weight: 600;
		font-size: 20px;
		line-height: 24px;
		margin-bottom: 12px;
	}
`;

export const TutorialMainStep: React.FC = () => {
	const {t} = useTranslation();

	useEffect(() => {
		AdobeAnalyticService.TrackState(
			{
				"page.name": AdobeTrackStateActions.WelcomeModal,
				"page.viewType": "",
				"page.viewSubType": "",
			},
			true
		);
	}, []);

	return (
		<Wrapper>
			<img src={logoAsset} alt="MLB BTN" />

			<p className="title">{t("modal.tutorial.introduce_title")}</p>
			<p>{t("modal.tutorial.introduce_text")}</p>
		</Wrapper>
	);
};
